import React, { createContext, useContext, useState } from "react";
import { toast } from "react-toastify";

// Create the context
const NotificationContext = createContext();

// Custom hook for accessing the context
export const useNotifications = () => {
  return useContext(NotificationContext);
};

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  // Add a notification
  const addNotification = (notification) => {
    setNotifications((prev) => [...prev, notification]);
    // Show the toast notification
    // toast(notification.name, {
    //   toastId: notification.id, // Ensure unique toast for each notification
    //   autoClose: false,
    //   closeOnClick: false,
    //   style: { backgroundColor: notification.color || "#fff" },
    // });
  };

  // Update a notification
  const updateNotification = (updatedNotification) => {
    setNotifications((prev) =>
      prev.map((notif) =>
        notif.id === updatedNotification.id
          ? { ...notif, ...updatedNotification }
          : notif
      )
    );
    // Update the toast notification
    // toast.update(updatedNotification.id, {
    //   render: updatedNotification.name,
    //   style: { backgroundColor: updatedNotification.color || "#fff" },
    // });
  };

  // Clear all notifications
  const clearAll = () => {
    setNotifications([]);
    // toast.dismiss(); // Dismiss all active toasts
  };

  // Mark all notifications as read
  const markAllAsRead = () => {
    setNotifications((prev) => prev.map((notif) => ({ ...notif, read: true })));
    // Optionally update toast for each notification
    // notifications.forEach((notif) => {
    //   toast.update(notif.id, {
    //     render: notif.name,
    //     style: { backgroundColor: "#ccc" }, // For example, change style when read
    //   });
    // });
  };

  // Mark a specific notification as read
  const markAsRead = (id) => {
    setNotifications((prev) =>
      prev.map((notif) => (notif.id === id ? { ...notif, read: true } : notif))
    );
    // Optionally update toast for the specific notification
    const notif = notifications.find((n) => n.id === id);
    // if (notif) {
    //   toast.update(id, {
    //     render: notif.name,
    //     style: { backgroundColor: "#ccc" },
    //   });
    // }
  };

  // Remove a specific notification
  const remove = (id) => {
    setNotifications((prev) => prev.filter((notif) => notif.id !== id));
    // toast.dismiss(id); // Dismiss the toast associated with the notification
  };

  return (
    <NotificationContext.Provider
      value={{
        notifications,
        addNotification,
        updateNotification,
        clearAll,
        markAllAsRead,
        markAsRead,
        remove,
        unreadCount: notifications.filter((notif) => !notif.read).length,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};
